var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha, styled, useTheme } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import * as Preact from 'preact';
var StyledSwitch = styled(Switch)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiSwitch-switchBase': {
            color: theme.palette.background.default,
            '&:hover': {
                borderRadius: '50%',
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
            },
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            color: theme.palette.primary.main,
            opacity: 1,
        },
    });
});
export var Component = function (p) {
    var theme = useTheme();
    return (Preact.h(FormControlLabel, { control: Preact.h(StyledSwitch, { defaultChecked: p.defaultChecked, checked: p.checked, onChange: p.onChange, size: p.size, theme: theme }), label: p.label || null, labelPlacement: p.labelPlacement, sx: __assign({ margin: '0px' }, p.sx) }));
};
Component.displayName = 'Switch';
